import axios from 'axios';
import {
	reqF
} from './axiosFun';


// 获取数据字典数据列表
export const GetDicDataList = (params) => {
	return reqF("post", "/api/sysConfig/DicData/GetDicDataList", params)
};

// 保存数据字典
export const SaveDicData = (params) => {
	return reqF("post", "/api/sysConfig/DicData/SaveDicData", params)
};

// 删除数据字典
export const DeleteDicData = (params) => {
	return reqF("post", "/api/sysConfig/DicData/DeleteDicData", params)
};

// 获取根据父节点code获取子节点列表
export const GetDicDataListByParentCode = (params) => {
	return reqF("post", "/api/sysConfig/DicData/GetDicDataListByParentCode", params)
};

// 根据keyId获取数据字典信息
export const GetDicDataByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/DicData/GetDicDataByKeyId", params)
};

// 根据节点Code获取数据字典信息
export const GetDicDataByCode = (params) => {
	return reqF("post", "/api/sysConfig/DicData/GetDicDataByCode", params)
};

// GetDicDataTreeByParentCode
export const GetDicDataTreeByParentCode = (params) => {
	return reqF("post", "/api/sysConfig/DicData/GetDicDataTreeByParentCode", params)
};
